import Controller from './events-list.controller';
import template from './events-list.html';
import './events-list.less';

const Component = {
    template,
    controller: [
        '$state',
        'crErrorLoggingService',
        'crAnalyticsService',
        'crToastService',
        'crLocaleService',
        'crConfig',
        'crEventsListService',
        '$q',
        'crEntitySelectionManager',
        Controller,
    ],
};

export default Component;
